import { addDays, format } from 'date-fns';

const getBeginDatumVariation = () => {
  let date = new Date();

  // Gebruikt gisteren wanneer datum tussen 00:00 en 01:59 is
  if (date.getHours() < 2) {
    date = addDays(date, -1);
  }
  return date;
};
export type DayVariant = {
  label: string;
  value: string;
};

export const getDateVariations = (): DayVariant[] => {
  const date = getBeginDatumVariation();
  return [
    {
      label: `${format(date, 'dd-MM-yyyy')} (vandaag)`,
      value: format(date, 'yyyy-MM-dd'),
    },
    {
      label: `${format(addDays(date, 1), 'dd-MM-yyyy')} (morgen)`,
      value: format(addDays(date, 1), 'yyyy-MM-dd'),
    },
    {
      label: `${format(addDays(date, 2), 'dd-MM-yyyy')} (overmorgen)`,
      value: format(addDays(date, 2), 'yyyy-MM-dd'),
    },
    {
      label: `${format(addDays(date, -1), 'dd-MM-yyyy')} (gisteren)`,
      value: format(addDays(date, -1), 'yyyy-MM-dd'),
    },
  ];
};

export const getDateVariationsForAdvancedSearch = (): DayVariant[] => {
  const date = getBeginDatumVariation();
  return [
    { label: 'vandaag vanaf nu', value: `nu-${format(date, 'yyyy-MM-dd')}` },
    {
      label: `${format(date, 'dd-MM')} (vandaag)`,
      value: format(date, 'yyyy-MM-dd'),
    },
    {
      label: `${format(addDays(date, 1), 'dd-MM')} (morgen)`,
      value: format(addDays(date, 1), 'yyyy-MM-dd'),
    },
    {
      label: `${format(addDays(date, 2), 'dd-MM')} (overmorgen)`,
      value: format(addDays(date, 2), 'yyyy-MM-dd'),
    },
    {
      label: `${format(addDays(date, -1), 'dd-MM')} (gisteren)`,
      value: format(addDays(date, -1), 'yyyy-MM-dd'),
    },
    {
      label: `van ${format(addDays(date, -1), 'dd-MM-yyyy')} tot ${format(addDays(date, 1), 'dd-MM-yyyy')}`,
      value: `${format(addDays(date, -1), 'yyyy-MM-dd')}-${format(addDays(date, 1), 'yyyy-MM-dd')}`,
    },
  ];
};

export type DaySelectionVariant = {
  description: string;
  date: string;
  shortDescription: string;
};
export const getDaySelectionVariations = (version: number = 1): DaySelectionVariant[] => {
  const date = getBeginDatumVariation();
  if (version === 1)
    return [
      {
        description: ` op ${format(date, 'dd-MM-yyyy')} (vandaag)`,
        shortDescription: `op ${format(date, 'dd-MM-yyyy')}`,
        date: format(date, 'yyyy-MM-dd'),
      },
      {
        description: ` op ${format(addDays(date, 1), 'dd-MM-yyyy')} (morgen)`,
        shortDescription: ` op ${format(addDays(date, 1), 'dd-MM-yyyy')}`,
        date: format(addDays(date, 1), 'yyyy-MM-dd'),
      },
      {
        description: ` op ${format(addDays(date, 2), 'dd-MM-yyyy')} (overmorgen)`,
        shortDescription: ` op ${format(addDays(date, 2), 'dd-MM-yyyy')}`,
        date: format(addDays(date, 2), 'yyyy-MM-dd'),
      },
      {
        description: ` op ${format(addDays(date, -1), 'dd-MM-yyyy')} (gisteren)`,
        shortDescription: ` op ${format(addDays(date, -1), 'dd-MM-yyyy')}`,
        date: format(addDays(date, -1), 'yyyy-MM-dd'),
      },
      {
        description: ` van ${format(addDays(date, -1), 'dd-MM-yyyy')} t/m ${format(addDays(date, 2), 'dd-MM-yyyy')}`,
        date: '',
        shortDescription: '',
      },
    ];
  return [
    {
      description: ` op ${format(date, 'dd-MM-yyyy')} (vandaag)`,
      shortDescription: `Vandaag ${format(date, 'dd-MM')}`,
      date: format(date, 'yyyy-MM-dd'),
    },
    {
      description: ` op ${format(addDays(date, 1), 'dd-MM-yyyy')} (morgen)`,
      shortDescription: `Morgen ${format(addDays(date, 1), 'dd-MM')}`,
      date: format(addDays(date, 1), 'yyyy-MM-dd'),
    },
    {
      description: ` op ${format(addDays(date, 2), 'dd-MM-yyyy')} (overmorgen)`,
      shortDescription: `Overmorgen ${format(addDays(date, 2), 'dd-MM')}`,
      date: format(addDays(date, 2), 'yyyy-MM-dd'),
    },
    {
      description: ` op ${format(addDays(date, -1), 'dd-MM-yyyy')} (gisteren)`,
      shortDescription: `Gisteren ${format(addDays(date, -1), 'dd-MM')}`,
      date: format(addDays(date, -1), 'yyyy-MM-dd'),
    },
    {
      description: ` van ${format(addDays(date, -1), 'dd-MM-yyyy')} t/m ${format(addDays(date, 2), 'dd-MM-yyyy')}`,
      date: '',
      shortDescription: `Alle ${format(addDays(date, -1), 'dd-MM')} t/m ${format(addDays(date, 2), 'dd-MM')}`,
    },
  ];
};

export const getDaySelectionVariationsForCarouselButton = (): DayVariant[] => {
  const date = getBeginDatumVariation();
  return [
    {
      label: ` op ${format(date, 'dd-MM-yyyy')} (vandaag)`,
      value: format(date, 'yyyy-MM-dd'),
    },
    {
      label: ` op ${format(addDays(date, 1), 'dd-MM-yyyy')} (morgen)`,
      value: format(addDays(date, 1), 'yyyy-MM-dd'),
    },
    {
      label: ` op ${format(addDays(date, 2), 'dd-MM-yyyy')} (overmorgen)`,
      value: format(addDays(date, 2), 'yyyy-MM-dd'),
    },
    {
      label: ` op ${format(addDays(date, -1), 'dd-MM-yyyy')} (gisteren)`,
      value: format(addDays(date, -1), 'yyyy-MM-dd'),
    },
    {
      label: ` van ${format(addDays(date, -1), 'dd-MM-yyyy')} t/m ${format(addDays(date, 2), 'dd-MM-yyyy')}`,
      value: '',
    },
  ];
};
